function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.519 28.8376H168.75V35.7095H157.87V54.3691H148.319V35.7095H137.519V28.8376Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.3428 49.2828L28.4858 51.8144L24.1244 50.6933L24.5436 47.7391L27.4978 48.1583L28.3428 49.2828Z",
  fill: "#C8A831"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.959 44.7887L25.102 47.3204L20.7406 46.1993L21.1598 43.2451L24.114 43.6643L24.959 44.7887Z",
  fill: "#C8A831"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5801 40.2897L21.7231 42.8214L17.3617 41.7002L17.7809 38.7461L20.7351 39.1653L21.5801 40.2897Z",
  fill: "#C8A831"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.7963 40.2686C22.623 36.6047 22.7866 31.3694 19.8716 27.4903C16.3715 22.8327 9.75839 21.8943 5.10069 25.3943C0.443094 28.8944 -0.495406 35.5076 3.00469 40.1652C5.60329 43.6233 9.91789 45.0312 13.8742 44.0946L22.0052 54.9148L27.9136 55.7532L28.4725 51.8143L27.205 50.1276L24.2508 49.7084L25.0925 47.3165L24.2476 46.192L20.7311 46.1953L21.7126 42.8186L19.7963 40.2686ZM13.822 31.1552C15.222 33.0183 14.8466 35.6635 12.9836 37.0636C11.1205 38.4636 8.47529 38.0882 7.07519 36.2252C5.67519 34.3621 6.05059 31.7168 7.91359 30.3168C9.77669 28.9168 12.422 29.2921 13.822 31.1552Z",
  fill: "url(#paint0_linear_28_188)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1479 42.6171C20.8631 38.967 21.3921 33.0404 18.1778 28.763C14.9661 24.4891 9.13319 23.3468 4.59509 25.8919C4.92539 25.5674 5.28089 25.2608 5.66119 24.9751C10.3189 21.475 16.932 22.4134 20.4321 27.0711C23.9322 31.7287 22.9938 38.3419 18.3361 41.842C17.9523 42.1303 17.5553 42.3886 17.1479 42.6171Z",
  fill: "#C8A831"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M210.867 28.8376V54.335L220.657 54.2744V45.4924H226.433L234.664 54.2667H245L236.604 45.3158C242.428 44.4127 244.603 40.4553 244.603 37.0975C244.603 33.1638 243.09 28.8376 233.279 28.8377L210.867 28.8376ZM220.626 34.5384H233.065C233.065 34.5384 235.519 34.5384 235.519 36.9706C235.519 39.4029 233.065 39.5937 233.065 39.5937H220.626V34.5384Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M169.942 40.9853C169.942 35.6469 172.373 28.3235 188.462 28.3235H190.061C206.15 28.3235 208.581 35.6469 208.581 40.9853V42.012C208.581 47.2478 206.118 54.8107 190.061 54.8107H188.462C172.437 54.8107 169.942 47.2478 169.942 42.012V40.9853ZM180.042 41.2895C180.042 38.7418 181.202 35.2469 188.88 35.2469H189.643C197.321 35.2469 198.481 38.7418 198.481 41.2895V41.7794C198.481 44.2781 197.306 47.8873 189.643 47.8873H188.88C181.233 47.8873 180.042 44.2781 180.042 41.7794V41.2895Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.058 28.8376H112.32V34.9748H93.607V38.4242H111.858V44.2423H93.607V48.097H112.32V54.335H84.058V28.8376Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.1934 28.8376H80.716V54.335H71.1934V28.8376Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.5698 28.9751L34.5699 53.7871L44.1701 53.7281V45.1823H51.651L58.0573 53.7207H67.2727L60.6242 44.8598C65.7242 43.7547 67.6525 40.1201 67.6525 37.0129C67.6525 33.185 66.1689 28.9751 56.5479 28.9752L34.5698 28.9751ZM44.1403 34.5226H55.9623C55.9623 34.5226 58.2949 34.5226 58.2949 36.8895C58.2949 39.2564 55.9623 39.4421 55.9623 39.4421H44.1403V34.5226Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.434 28.8376H125.063V47.0662H142.706V54.3691H115.434V28.8376Z",
  fill: "white"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.7142 56.4866L13.3423 58.5444L10.5986 55.1148L12.6564 53.057L14.7142 55.1148V56.4866Z",
  fill: "#C8A831"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.7142 50.9981L13.3423 53.0558L10.5986 49.6262L12.6564 47.5685L14.7142 49.6262V50.9981Z",
  fill: "#C8A831"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.7142 45.5121L13.3423 47.5699L10.5986 44.1403L12.6564 42.0825L14.7142 44.1403V45.5121Z",
  fill: "#C8A831"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3368 44.4529C17.6896 43.2538 20.8867 39.2666 20.8867 34.5327C20.8867 28.8503 16.2802 24.2439 10.5979 24.2439C4.9155 24.2439 0.309097 28.8503 0.309097 34.5327C0.309097 38.7499 2.8463 42.3745 6.4776 43.9633V57.1663L10.5931 61.2818L13.3368 58.5381V56.4803L11.279 54.4226L13.3368 53.0507V51.6789L10.5931 49.6211L13.3368 47.5634V44.4529ZM14.0288 33.8479C14.0288 36.1208 12.1862 37.9634 9.9133 37.9634C7.6404 37.9634 5.7978 36.1208 5.7978 33.8479C5.7978 31.5749 7.6404 29.7323 9.9133 29.7323C12.1862 29.7323 14.0288 31.5749 14.0288 33.8479Z",
  fill: "url(#paint1_linear_28_188)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2916 29.9719C10.8628 29.8204 10.4014 29.738 9.92071 29.738C7.64781 29.738 5.80521 31.5806 5.80521 33.8536C5.80521 36.1265 7.64781 37.9691 9.92071 37.9691C10.4014 37.9691 10.8628 37.8867 11.2916 37.7352C9.69271 37.1705 8.54701 35.6458 8.54701 33.8535C8.54701 32.0613 9.69271 30.5366 11.2916 29.9719Z",
  fill: "#C8A831"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.91339 24.345C14.9477 25.0152 18.8314 29.3257 18.8314 34.5433C18.8314 39.7608 14.9478 44.0712 9.91369 44.7415C10.3621 44.8012 10.8197 44.832 11.2844 44.832C16.9668 44.832 21.5732 40.2256 21.5732 34.5432C21.5732 28.8609 16.9668 24.2544 11.2844 24.2544C10.8196 24.2544 10.3619 24.2853 9.91339 24.345Z",
  fill: "#C8A831"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.127 74V65.3854H164.7C165.672 65.3854 166.442 65.5929 167.011 66.0079C167.579 66.4192 167.863 66.9782 167.863 67.6849C167.863 68.1896 167.702 68.5897 167.381 68.8851C167.059 69.1805 166.633 69.3786 166.102 69.4796C166.487 69.5244 166.84 69.6404 167.162 69.8273C167.484 70.0105 167.742 70.2573 167.936 70.5676C168.134 70.878 168.233 71.2481 168.233 71.6781C168.233 72.1343 168.115 72.5381 167.88 72.8895C167.644 73.2372 167.302 73.5102 166.854 73.7084C166.409 73.9028 165.872 74 165.244 74H161.127ZM162.703 72.5979H165.244C165.659 72.5979 165.984 72.4988 166.22 72.3006C166.455 72.1025 166.573 71.8333 166.573 71.493C166.573 71.0929 166.455 70.7789 166.22 70.5508C165.984 70.319 165.659 70.2031 165.244 70.2031H162.703V72.5979ZM162.703 68.9748H164.717C165.031 68.9748 165.3 68.9299 165.524 68.8402C165.752 68.7505 165.926 68.6234 166.046 68.4588C166.169 68.2906 166.231 68.0924 166.231 67.8643C166.231 67.5316 166.095 67.2717 165.822 67.0848C165.549 66.8978 165.175 66.8043 164.7 66.8043H162.703V68.9748ZM170.073 74V65.3854H171.75V74H170.073ZM170.92 64.0562C170.628 64.0562 170.378 63.959 170.168 63.7646C169.962 63.5664 169.86 63.3308 169.86 63.0579C169.86 62.7812 169.962 62.5456 170.168 62.3512C170.378 62.1531 170.628 62.054 170.92 62.054C171.211 62.054 171.46 62.1531 171.666 62.3512C171.875 62.5456 171.98 62.7812 171.98 63.0579C171.98 63.3308 171.875 63.5664 171.666 63.7646C171.46 63.959 171.211 64.0562 170.92 64.0562ZM173.164 76.4845V72.5474H173.866C174.045 72.3829 174.196 72.1866 174.32 71.9585C174.447 71.7304 174.553 71.4594 174.639 71.1453C174.729 70.8312 174.804 70.4648 174.864 70.046C174.924 69.6235 174.976 69.1412 175.021 68.5991L175.29 65.3854H181.145V72.5474H182.469V76.4845H180.831V74H174.825V76.4845H173.164ZM175.66 72.5474H179.508V66.8212H176.793L176.614 68.5991C176.528 69.5039 176.419 70.2891 176.288 70.9546C176.158 71.6164 175.948 72.1473 175.66 72.5474Z",
  fill: "white"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M216.595 70.5474C216.595 71.2282 215.979 71.8113 215.318 71.8113H214.673V73.7376H215.318C217.074 73.7376 218.516 72.2998 218.516 70.5474V66.9954H221.878V73.7376H223.8V65.0691H216.595V70.5474ZM232.445 69.883C232.445 71.2529 231.458 72.4855 230.092 72.4855H229.996C228.629 72.4855 227.642 71.4085 227.642 69.883V65.0691H225.721V69.883C225.721 72.7745 227.698 74.2192 229.996 74.2192H230.092C231.116 74.2192 231.917 73.8787 232.445 73.2561V73.834C232.445 75.6552 231.287 76.3864 230.092 76.3864H229.996C228.971 76.3864 228.015 75.6825 227.642 74.7796L226.043 75.3712C226.648 76.9122 228.257 78.0719 229.996 78.0719H230.092C232.545 78.0719 234.367 76.2779 234.367 73.834V65.0691H232.445V69.883ZM243.013 68.4402V65.0691H244.934V73.7377H243.013V70.3665H238.21V73.7377H236.288V65.0691H238.21V68.4402H243.013Z",
  fill: "white"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.411 63.9545V75.0472C189.411 75.1747 189.48 75.2921 189.592 75.3533L198.902 80.4476C199.007 80.5047 199.133 80.5047 199.237 80.4476L208.548 75.3533C208.66 75.2921 208.729 75.1747 208.729 75.0472V63.9546L199.235 58.8425C199.132 58.7869 199.008 58.7869 198.904 58.8425L189.411 63.9545Z",
  fill: "url(#paint2_linear_28_188)"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.07 69.2398L208.729 63.9546V75.2541L199.07 80.5393V69.2398Z",
  fill: "url(#paint3_linear_28_188)"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.07 69.3414L189.411 63.9546L199.07 58.7534L208.729 63.9546L199.07 69.3414Z",
  fill: "url(#paint4_linear_28_188)"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.07 69.2398L189.411 63.9546V75.2541L199.07 80.5393V69.2398Z",
  fill: "url(#paint5_linear_28_188)"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.411 63.9546L199.07 58.7534L208.729 63.9546V75.2541L199.07 80.5393L189.411 75.2541V63.9546Z",
  fill: "url(#paint6_linear_28_188)"
});

var _ref27 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask1_28_188)"
}, React.createElement("path", {
  d: "M199.07 69.2398L189.411 63.9546V75.2541L199.07 80.5393V69.2398Z",
  fill: "url(#paint7_linear_28_188)"
}), React.createElement("g", {
  filter: "url(#filter0_f_28_188)"
}, React.createElement("path", {
  d: "M189.225 63.7688L199.07 69.1557",
  stroke: "url(#paint8_linear_28_188)",
  strokeWidth: 0.407004,
  strokeLinecap: "round"
})), React.createElement("g", {
  filter: "url(#filter1_f_28_188)"
}, React.createElement("path", {
  d: "M208.915 63.7688L199.07 69.1557",
  stroke: "url(#paint9_linear_28_188)",
  strokeWidth: 0.407004,
  strokeLinecap: "round"
})), React.createElement("g", {
  filter: "url(#filter2_f_28_188)"
}, React.createElement("path", {
  d: "M199.07 81.2297V69.1557",
  stroke: "url(#paint10_linear_28_188)",
  strokeWidth: 0.407004,
  strokeLinecap: "round"
})), React.createElement("g", {
  filter: "url(#filter3_f_28_188)"
}, React.createElement("path", {
  d: "M189.225 63.7688L199.07 69.1557",
  stroke: "url(#paint11_linear_28_188)",
  strokeWidth: 0.34886,
  strokeLinecap: "round"
})), React.createElement("g", {
  filter: "url(#filter4_f_28_188)"
}, React.createElement("path", {
  d: "M208.915 63.7688L199.07 69.1557",
  stroke: "url(#paint12_linear_28_188)",
  strokeWidth: 0.34886,
  strokeLinecap: "round"
})), React.createElement("g", {
  filter: "url(#filter5_f_28_188)"
}, React.createElement("path", {
  d: "M199.07 81.2297V69.1557",
  stroke: "url(#paint13_linear_28_188)",
  strokeWidth: 0.34886,
  strokeLinecap: "round"
})));

var _ref28 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_f_28_188",
  x: 188.44,
  y: 62.9838,
  width: 11.415,
  height: 6.95684,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.290717,
  result: "effect1_foregroundBlur_28_188"
})), React.createElement("filter", {
  id: "filter1_f_28_188",
  x: 198.285,
  y: 62.9838,
  width: 11.4149,
  height: 6.95684,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.290717,
  result: "effect1_foregroundBlur_28_188"
})), React.createElement("filter", {
  id: "filter2_f_28_188",
  x: 198.285,
  y: 68.3707,
  width: 1.56985,
  height: 13.6439,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.290717,
  result: "effect1_foregroundBlur_28_188"
})), React.createElement("filter", {
  id: "filter3_f_28_188",
  x: 188.876,
  y: 63.4199,
  width: 10.5428,
  height: 6.0847,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.0872151,
  result: "effect1_foregroundBlur_28_188"
})), React.createElement("filter", {
  id: "filter4_f_28_188",
  x: 198.721,
  y: 63.4199,
  width: 10.5428,
  height: 6.0847,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.0872151,
  result: "effect1_foregroundBlur_28_188"
})), React.createElement("filter", {
  id: "filter5_f_28_188",
  x: 198.721,
  y: 68.8068,
  width: 0.697737,
  height: 12.7717,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.0872151,
  result: "effect1_foregroundBlur_28_188"
})), React.createElement("linearGradient", {
  id: "paint0_linear_28_188",
  x1: -0.986506,
  y1: 17.2938,
  x2: 34.0013,
  y2: 63.8533,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F7D341"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C628"
})), React.createElement("linearGradient", {
  id: "paint1_linear_28_188",
  x1: 10.5979,
  y1: 24.2439,
  x2: 10.5979,
  y2: 61.2819,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F7D341"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E9C628"
})), React.createElement("linearGradient", {
  id: "paint2_linear_28_188",
  x1: 199.07,
  y1: 68.0475,
  x2: 189.441,
  y2: 75.3008,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF5201"
}), React.createElement("stop", {
  offset: 0.510417,
  stopColor: "#EB3D00"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#D42600"
})), React.createElement("linearGradient", {
  id: "paint3_linear_28_188",
  x1: 208.547,
  y1: 64.3191,
  x2: 199.252,
  y2: 80.5393,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8004"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5201"
})), React.createElement("linearGradient", {
  id: "paint4_linear_28_188",
  x1: 199.07,
  y1: 58.9392,
  x2: 199.07,
  y2: 69.3414,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF6605"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8A06"
})), React.createElement("linearGradient", {
  id: "paint5_linear_28_188",
  x1: 199.07,
  y1: 68.0412,
  x2: 189.411,
  y2: 75.2856,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF5201"
}), React.createElement("stop", {
  offset: 0.510417,
  stopColor: "#EB3D00"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#D42600"
})), React.createElement("linearGradient", {
  id: "paint6_linear_28_188",
  x1: 199.07,
  y1: 68.0412,
  x2: 189.411,
  y2: 75.2856,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF5201"
}), React.createElement("stop", {
  offset: 0.510417,
  stopColor: "#EB3D00"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#D42600"
})), React.createElement("linearGradient", {
  id: "paint7_linear_28_188",
  x1: 197.212,
  y1: 68.5985,
  x2: 194.983,
  y2: 78.6292,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF0101",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#DD2800",
  stopOpacity: 0.71
})), React.createElement("linearGradient", {
  id: "paint8_linear_28_188",
  x1: 189.411,
  y1: 64.3261,
  x2: 199.07,
  y2: 69.5272,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8708"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), React.createElement("linearGradient", {
  id: "paint9_linear_28_188",
  x1: 208.915,
  y1: 63.7688,
  x2: 199.256,
  y2: 68.9699,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF9B06"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), React.createElement("linearGradient", {
  id: "paint11_linear_28_188",
  x1: 189.411,
  y1: 64.3261,
  x2: 199.07,
  y2: 69.5272,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8708"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), React.createElement("linearGradient", {
  id: "paint12_linear_28_188",
  x1: 208.915,
  y1: 63.7688,
  x2: 199.256,
  y2: 68.9699,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF9B06"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})));

var SvgLogoBig = function SvgLogoBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 245,
    height: 82,
    viewBox: "0 0 245 82",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, React.createElement("mask", {
    id: "mask0_28_188",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 58,
    width: 20,
    height: 23
  }, _ref22), React.createElement("g", {
    mask: "url(#mask0_28_188)"
  }, _ref23, _ref24, _ref25, React.createElement("mask", {
    id: "mask1_28_188",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 58,
    width: 20,
    height: 23
  }, _ref26), _ref27), _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-big.61bd47a8.svg";
export { ForwardRef as ReactComponent };